import { DocumentNode, gql } from '@apollo/client';
import { Box, Divider, HStack, Text } from '@chakra-ui/react';
import * as React from 'react';

import { AlertCircleIcon } from '@/imports/ui/chakra/feather';

const POST_FRAGMENT = gql`
  fragment DeletedHeader_PostFragment on PostV2 {
    _id
    ... on AnswerV2 {
      _id
    }
  }
`;

export const DeletedHeader: React.FC<{
  post: any;
  isAnswerHeader: boolean;
}> & { postFragment: DocumentNode } = ({ post, isAnswerHeader }) => {
  return (
    <Box px="4" pt="4">
      {post.__typename === 'AnswerV2' && !isAnswerHeader ? (
        <HStack alignItems="center">
          <AlertCircleIcon color="red.500" />
          <Text textStyle="compact" as="span" flexGrow="1">
            The original question was deleted
          </Text>
        </HStack>
      ) : (
        <HStack alignItems="center">
          <AlertCircleIcon color="red.500" />
          <Text textStyle="compact" as="span" flexGrow="1">
            This post was deleted
          </Text>
        </HStack>
      )}
      <Divider pt="4" />
    </Box>
  );
};
DeletedHeader.postFragment = POST_FRAGMENT;
